<template>
  <div class="">
    <card class="mt-15">
      <div slot="header">
        <h3 class="card-title">추가 정보 동의</h3>
      </div>
      <div class="row m-row">
        <div class="fl col-lg-6">
          <h5>
            * 공인중개사법 제18조의2(중개대상물의 표시·광고) 개정안에 의거하여
            의뢰인이 원치 않으실 경우, 다음과 같이 공개할 정보를 선택하실 수
            있습니다.
          </h5>
          <ul class="pptInquiry_addData_Ul">
            <li>단독주택의 경우 지번을 읍․면․동․리까지 표시 가능</li>
            <li>공동주택의 경우 층을 저중고 로 대체 가능</li>
          </ul>
        </div>
        <div class="fl col-lg-6 jipvio-bg-color5">
          <h4 class="jipvio-text-center mt-10">
            &lt;상세주소 표시·광고 여부 선택&gt;
          </h4>
          <div>
            <div class="fl col-md-6">
              <h5>1. 단독주택일 경우</h5>
              <el-checkbox
                v-model="oneHouseAgr"
                label="읍,면,동,리 까지만 표시"
                @change="$emit('oneHouseAgr', oneHouseAgr)"
              ></el-checkbox>
            </div>
            <div class="fl col-md-6">
              <h5>2. 공동주택일 경우</h5>
              <el-checkbox
                v-model="shareHouseAgr"
                label="층을 저중고로 표시"
                @change="$emit('shareHouseAgr', shareHouseAgr)"
              ></el-checkbox>
            </div>
            <h6 class="jipvio-text-left pl-15 pt-10 pb-10 cl-bth">
              위에 사항을 선택하지 않을 경우, 단독주택: 지번 포함 표시 /
              단독주택 외: 지번과 동, 층수를 포함 표시 합니다.
            </h6>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import { Card, Checkbox } from "element-ui";
import { createNamespacedHelpers, mapGetters } from "vuex";

const { mapGetters: sessionMapGetters } = createNamespacedHelpers(
  "loginSession"
);
export default {
  components: {
    Card,
    [Checkbox.name]: Checkbox
  },

  data() {
    return {
      oneHouseAgr: null, //단독주택일 경우 동의 체크박스
      shareHouseAgr: null //공동주택일 경우 동의 체크박스
    };
  },

  created() {},

  computed: {
    ...sessionMapGetters({
      sessionPropertyInquiry: "getPropertyInquiry"
    })
  },
  methods: {
    bringData() {
      this.oneHouseAgr = this.sessionPropertyInquiry.propertyInfo.oneHouseAgr; //단독주택일 경우 동의 체크박스
      this.shareHouseAgr = this.sessionPropertyInquiry.propertyInfo.shareHouseAgr; //공동주택일 경우 동의 체크박스
    },
    SendData() {
      this.$emit("oneHouseAgr", oneHouseAgr);
      this.$emit("shareHouseAgr", shareHouseAgr);
    }
  }
};
</script>

<style></style>
